import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["target", "template"]

    add(event) {
        event.preventDefault()
        const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
        this.targetTarget.insertAdjacentHTML("beforeend", content)

        // Aggressive focus strategy: wait 100ms, find the very last text input, scroll to it, and focus
        setTimeout(() => {
            const inputs = this.targetTarget.querySelectorAll("input[type='text']")
            const lastInput = inputs[inputs.length - 1]
            if (lastInput) {
                lastInput.scrollIntoView({ behavior: 'smooth', block: 'center' })
                lastInput.focus()
            }
        }, 100)
    }

    remove(event) {
        event.preventDefault()
        const wrapper = event.target.closest(".nested-form-wrapper")
        if (wrapper.dataset.newRecord === "true") {
            wrapper.remove()
        } else {
            wrapper.querySelector("input[name*='_destroy']").value = 1
            wrapper.style.display = "none"
        }
    }
}
